export type CompensationComponentKey = "basic" | "pfEmployeePart" | "esicEmployeePart" | "specialAllowance" | "houseRentAllowance" | "internetReimbursement" | "gratuity" | "pfEmployerPart" | "esicEmployerPart";

export const COMPENSATION_COMPONENTS: ReadonlyArray<{ key: CompensationComponentKey; label: string; group: string; editable: boolean }> = [
  { key: "basic", label: "Basic Salary", group: "A. Essentials", editable: false },
  { key: "pfEmployeePart", label: "Provident Fund (Employee Contribution)", group: "A. Essentials", editable: true },
  { key: "esicEmployeePart", label: "ESIC (Employees' State Insurance Corporation)", group: "A. Essentials", editable: false },
  { key: "specialAllowance", label: "Special Allowance", group: "B. Allowances", editable: false },
  { key: "houseRentAllowance", label: "House Rent Allowance", group: "B. Allowances", editable: false },
  { key: "internetReimbursement", label: "Internet Allowance", group: "C. Monthly Reimbursements", editable: true },
  { key: "gratuity", label: "Gratuity", group: "D. Statutory Benefits", editable: false },
  { key: "pfEmployerPart", label: "Provident Fund (Employer Contribution)", group: "D. Statutory Benefits", editable: true },
  { key: "esicEmployerPart", label: "ESIC (Employees' State Insurance Corporation)", group: "D. Statutory Benefits", editable: false },
];

export const APPRAISAL_MONEY = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});
